import { Component, OnInit, ViewChild } from '@angular/core';
import { BnSessionTimeoutService } from './services/bn-session-timeout-service';
import { UserManagementService, GetOwnUser as UserInfo } from '@backbase/data-ang/user';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {NotificationService} from "@backbase/ui-ang";
import { Router } from '@angular/router';
import { SharedUserContextService } from 'user-context';


@Component({
  selector: 'bn-bn-select-context-extended',
  templateUrl: './bn-select-context-extended.component.html',
  styleUrls: ['./bn-select-context-extended.component.scss'],
  providers: [BnSessionTimeoutService],
})
export class BnSelectContextExtendedComponent implements OnInit {
  isCreateCard100 = false;
  isCreateCardHeader = false;
  isCreateListInfiniteScroll = false;
  isCreateDivBackBtn = false;
  isRenderDOM = false;

  userFullName = "";

  readonly $userInfo: Observable<UserInfo | undefined> = this.userService
    .getOwnUser()
    .pipe(catchError(() => of(undefined)));

  constructor(
    private readonly sessionTimeoutService: BnSessionTimeoutService,
    private readonly userService: UserManagementService,
    private notificationService: NotificationService,
    private router: Router,
    public readonly userContextService: SharedUserContextService
  ) {}

  ngAfterViewChecked(): void {
    if(!this.isRenderDOM) {
      this.isRenderDOM = true;
      setTimeout(() => {
        let selectContextContainer = document.getElementsByClassName("bb-select-context__container card card-body")[0];

        let headerUi = document.getElementsByTagName("bb-header-ui")[0];
        if(headerUi) {
          if(!this.isCreateCardHeader) {
            headerUi.className = 'card-header bn-card-header pl-0';

            //@ts-ignore
            let headerText = headerUi.children[0].innerText;
            headerUi.innerHTML = '<h3>'+headerText+'</h3>';

            let elemUsername = document.createElement('div');
            elemUsername.className = "pb-3";
            //
            elemUsername.innerText = $localize`:@@select-context.view.label.logged-in-as:You are logged in as` + ": " + this.userFullName;
            headerUi.appendChild(elemUsername)
          }
        }

        //Se elimina un div
        let contextLbl = document.getElementsByClassName("bb-subheader bb-subheader--regular bb-text-support bb-text-bold pl-2")[0];
        if(contextLbl) {
          contextLbl.remove();
        }

        let subheaders = document.getElementsByClassName("bb-subheader bb-subheader--regular bb-text-support bb-select-context-ellipsis");
        Array?.prototype?.forEach?.call(subheaders, function(element) {
          element.className = "bb-subtitle bb-text-support";
        });

        let subtitles = document.getElementsByClassName("bb-text-bold bb-subtitle bb-select-context-ellipsis");
        Array?.prototype?.forEach?.call(subtitles, function(element) {
          element.className = "bb-text-bold";
        });



        //Boton de regresar
        if(!this.isCreateDivBackBtn) {
          this.isCreateDivBackBtn = true;
          let btnDiv = document.createElement('div');
          btnDiv.className = "card-footer";
          let btnGoBack = document.createElement('button');
          btnGoBack.className = "btn btn-outline-primary bb-button-bar__button";
          let btnGoBackSpan = document.createElement('span');
          btnGoBackSpan.innerText = $localize`:@@select-context.label.backButton:Back`;

          btnGoBack.addEventListener("click", () => {
            this.logout();
          });

          btnGoBack.insertBefore(btnGoBackSpan, btnGoBack.firstChild);
          btnDiv.insertBefore(btnGoBack, btnDiv.firstChild);

          selectContextContainer.appendChild(btnDiv);
        }

      }, 1500)
    }

  }

  ngOnInit() {
    this.$userInfo.subscribe(userInfo=> {this.userFullName = userInfo ? userInfo.fullName : ''});
  }

  pruebaConsola(param: string) {
    console.log(param, param)
  }


  async logout() {
    sessionStorage.removeItem('isUserContextSet');
    await this.sessionTimeoutService.logout();
    return this.goToLoginPage();
  }

  selectContext() {
    this.router.navigate(['/','home', `accounts`]);
  }

  private goToLoginPage() {
    this.sessionTimeoutService.goToLoginPage();
  }

  onSelectServiceAgreement(hostRef: any, serviceAgreement: any, userId: string){
    this.sessionTimeoutService.loginEvent(serviceAgreement.id, userId)
      .subscribe(() => {
        hostRef.select(serviceAgreement);
      },
        () => {
          this.notificationService.showNotification({
            header: $localize`:@@load-error-message-curr:Something went wrong. Reload the page or contact system administrator.`,
            message: '',
            modifier: 'error',
            ttl: 5000,
          });
        })
  }

  onValueChange(search: string, hostRef: any) {
    if (!search) {
      hostRef.search('');
    }
  }
}
